import { User } from "../../types/User";

export const sanitizeUser = (u: Omit<User, 'id'>) => {
    const newUser = {...u};
    newUser.email = newUser.email === '' ? null : newUser.email;
    return newUser;
};